import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, useNavigate } from 'react-router-dom';
import App from './App';
import { redirectToHostedUI, getStoredCredentials, handleCallback } from './auth';

const Callback = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleAuth = async () => {
            await handleCallback();
            navigate('/');
        };
        handleAuth();
    }, [navigate]);

    return <div>Loading...</div>;
};

const Root = () => {
    useEffect(() => {
        const credentials = getStoredCredentials();
        if (!credentials) {
            redirectToHostedUI();
        }
    }, []);

    return <App />;
};

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
    <Router>
        <Routes>
            <Route path="/callback" element={<Callback />} />
            <Route path="/" element={<Root />} />
        </Routes>
    </Router>
);